import { FC } from "react";

import { TruncatedText } from "@/components/_molecules/truncated-text/truncated-text";
import { cn } from "@/lib/cn";

import { Priority } from "../models/priority-model";

import { PriorityIcon } from "./priority-icon";
import { PriorityViewEmpty } from "./priority-view-empty";

interface PriorityViewProps {
  priority: Priority | null;
  logoOnly?: boolean;
  canTruncateLabel?: boolean;
  className?: string;
}

export const PriorityView: FC<PriorityViewProps> = ({ priority, canTruncateLabel = false, ...props }) => {
  if (!priority) {
    return <PriorityViewEmpty {...props} canTruncateLabel={canTruncateLabel} />;
  }

  return (
    <div className={cn(["flex flex-row items-center gap-2", canTruncateLabel && "min-w-0"])}>
      <PriorityIcon priority={priority} className={cn(["h-4 w-4 shrink-0", props.className])} />
      {!props.logoOnly && <TruncatedText text={priority.name} canTruncate={canTruncateLabel} />}
    </div>
  );
};
